import z from 'zod';
import { customEventBaseFields } from './base-fields';

const fileSchemas = {
  downloaded: z.object({
    ...customEventBaseFields,
    name: z.string().optional(),
    id: z.string().optional(),
    source: z.string().optional(),
    extension: z.string().optional(),
    url: z.string().url().optional(),
  }),
};

export default fileSchemas;
